<template>
  <div class="p-4">
    <h3 class="text-2xl font-semibold mb-4 text-stone-800 dark:text-stone-100">{{ wheelTitle }}
      <span v-if="editable" class="text-lg ml-2">
        <div class="relative group inline-block">
          <i class="fas fa-edit cursor-pointer text-stone-300 hover:text-stone-500 dark:text-stone-500 dark:hover:text-stone-300"
            @click="$emit('editTitleAndDescription')"></i>
          <div
            class="absolute hidden group-hover:block bg-white dark:bg-stone-800 text-stone-800 dark:text-stone-100 rounded-md py-1 px-2 text-sm shadow-md z-10 -mt-1 ml-6 whitespace-nowrap">
            {{ t('common.Edit title and description') }}
          </div>
        </div>
      </span>
    </h3>
    <p class="text-stone-700 dark:text-stone-300">
      {{ wheelDescription }}
    </p>
    <br />
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { useWheelStore } from '@/stores/useWheelStore';

const { t } = useI18n();
const emit = defineEmits(['editTitleAndDescription']);
defineProps({ editable: Boolean });

const wheelStore = useWheelStore();
const wheelConfig = computed(() => wheelStore.wheelConfig);
const wheelTitle = computed(() => wheelConfig.value?.title);
const wheelDescription = computed(() => wheelConfig.value?.description);
</script>
<script>
// Options API block removed in favor of <script setup>
</script>

<style scoped></style>
